import React from 'react';
import styles from './styles.module.css';
import { FilterButton } from '../../components';
const SortByLine = () => {
  return (
    <div className={styles.main}>
      <FilterButton text={'Most Popular'} />
      <FilterButton text={'Lowest Price'} />
      <FilterButton text={'Highest Guest Rating'} />
      <FilterButton text={'Distance'} />
    </div>
  );
};
export default SortByLine;
